import { Button, Flex, Text } from '@chakra-ui/react';
import CompaniesSettingsService from 'api/services/CompaniesSettingsService';
import aloware from 'assets/img/api-allow.png';
import close from 'assets/img/api-close.png';
import CardMy from 'components/CardMy';
import BigTitle from 'components/CardMy/BigTitle';
import CopyButton from 'components/CopyButton';
import Dialog from 'components/Dialog';
import InputMy from 'components/InputMy';
import Loader from 'components/Loader';
import UpdateCancel from 'components/UpdateCancel';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { TApiData, fetchApis, selectApis, selectApisIsLoading } from 'store/slices/companySetting';
import { PLATFORMS } from 'store/types';

const getImg = (name: PLATFORMS) => {
    const images = {
        [PLATFORMS.aloware]: aloware,
        [PLATFORMS.close]: close,
    };
    return images[name];
};

const APIDialog = ({ data }: { data: Array<string> }) => {
    return (
        <Dialog
            size="xl"
            title={'Alloware: API Links'}
            withoutSubmit
            trigger={
                <Button height="40px" padding="0 16px" variant="outline" isDisabled={!data.length}>
                    API Links
                </Button>
            }
        >
            <Flex flexDirection="column" gap="24px">
                {data.map((item, index) => (
                    <InputMy
                        key={index}
                        readOnly
                        label={'API Link ' + (index + 1)}
                        value={item}
                        rightElement={<CopyButton value={item} />}
                    />
                ))}
            </Flex>
        </Dialog>
    );
};

const ApiCard = ({ data }: { data: TApiData }) => {
    const dispatch = useAppDispatch();
    const { key, name, endpoints, id, companyId } = data;

    const [value, setValue] = useState(key as string);
    const [loading, setLoading] = useState(false);
    const handleCancel = () => setValue(key);

    const disabled = value === key;

    const handleSave = async () => {
        try {
            setLoading(true);
            await CompaniesSettingsService.integrationsApisUpdate({ companyId, id, key: value })
                .then(() => {
                    showMessage('updated');
                    dispatch(fetchApis());
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (error) {}
    };

    return (
        <Flex
            padding="24px"
            borderRadius="16px"
            border="1px"
            borderColor="gray.100"
            background="gray.50"
            flexDirection="column"
            gap="24px"
        >
            <Flex justifyContent="space-between" alignItems="center">
                <Flex alignItems="center" gap="8px">
                    <Flex
                        width="24px"
                        height="24px"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="50%"
                        border="1px"
                        borderColor="gray.200"
                        bg="white"
                    >
                        <img src={getImg(name)} alt="" />
                    </Flex>
                    <Text
                        color="gray.900"
                        fontSize="20px"
                        fontWeight={700}
                        lineHeight={1}
                        textTransform={'capitalize'}
                        letterSpacing="-0.4px"
                    >
                        {name}
                    </Text>
                </Flex>
                <APIDialog data={endpoints} />
            </Flex>
            <InputMy
                placeholder="Enter api key"
                sxInput={{ bg: 'white' }}
                label="API Integration"
                value={value}
                onChangeValue={setValue}
            />
            <UpdateCancel disabled={disabled} loading={loading} onCancel={handleCancel} onSave={handleSave} />
        </Flex>
    );
};

const APIServices = () => {
    const dispatch = useAppDispatch();
    const data = useAppSelector(selectApis);
    const isLoading = useAppSelector(selectApisIsLoading);
    console.log(data);

    useEffect(() => {
        dispatch(fetchApis());
    }, []);

    return (
        <div>
            <CardMy>
                <Flex flexDirection="column" gap="24px">
                    <BigTitle>API Services</BigTitle>
                    <Flex flexDirection="column" gap="8px">
                        {isLoading ? <Loader /> : data.map(item => <ApiCard key={item.id} data={item} />)}
                    </Flex>
                </Flex>
            </CardMy>
        </div>
    );
};

export default APIServices;
